// extracted by mini-css-extract-plugin
export default {"split":"validateBankAc_split__olg4N"};